"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ramda = require("ramda");

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _CalendarSettingDayTime = _interopRequireDefault(require("./CalendarSettingDayTime"));

var _CalendarSetting = require("./CalendarSetting.shape");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    title: {
      width: 150,
      paddingTop: 20
    }
  };
});

var CalendarSettingDay = function CalendarSettingDay(_ref) {
  var day = _ref.day,
      errors = _ref.errors,
      onAddSlot = _ref.onAddSlot,
      onToggleDay = _ref.onToggleDay,
      slotActions = (0, _objectWithoutProperties2.default)(_ref, ["day", "errors", "onAddSlot", "onToggleDay"]);
  var id = day.id,
      dayName = day.dayName,
      enabled = day.enabled,
      slots = day.slots;
  var classes = useStyles();
  var addSlotHandler = (0, _react.useCallback)(function () {
    return onAddSlot(id);
  }, [id, onAddSlot]);
  var toggleDayHandler = (0, _react.useCallback)(function (event, value) {
    return onToggleDay(id, value);
  }, [id, onToggleDay]);
  var showRemoveButton = (0, _react.useMemo)(function () {
    return slots.length > 1;
  }, [slots]);
  var _errors$days = errors.days,
      errorDays = _errors$days === void 0 ? [] : _errors$days,
      _errors$message = errors.message,
      message = _errors$message === void 0 ? '' : _errors$message;
  var hasDayOverlap = (0, _react.useMemo)(function () {
    return (0, _ramda.includes)(day.id, errorDays);
  }, [day, errorDays]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mr: 2,
    className: classes.title
  }, /*#__PURE__*/_react.default.createElement(_material.FormControl, {
    error: hasDayOverlap
  }, /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      checked: enabled,
      onChange: toggleDayHandler,
      value: "enabled",
      color: "primary"
    }),
    label: dayName
  }), hasDayOverlap && /*#__PURE__*/_react.default.createElement(_material.FormHelperText, null, message))), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 2
  }, slots.map(function (slot, index) {
    var showAddButton = enabled && index === slots.length - 1;
    return /*#__PURE__*/_react.default.createElement(_CalendarSettingDayTime.default, (0, _extends2.default)({
      key: slot.id,
      slot: slot,
      isRemovable: showRemoveButton,
      showAddButton: showAddButton,
      disabled: !enabled,
      onAddSlot: addSlotHandler
    }, slotActions));
  })));
};

CalendarSettingDay.propTypes = {
  day: _CalendarSetting.CalendarDay.isRequired,
  onToggleDay: _propTypes.default.func.isRequired,
  onAddSlot: _propTypes.default.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  errors: _propTypes.default.object
};
CalendarSettingDay.defaultProps = {
  errors: {}
};

var _default = /*#__PURE__*/(0, _react.memo)(CalendarSettingDay);

exports.default = _default;